import * as React from "react";
import { Popover, Typography } from "@mui/material";
import SupportEmailLink from "./SupportEmailLink";
import {
  SUPPORT_EMAIL,
  SUPPORT_PHONE,
  SUPPORT_PHONE_FORMAT,
} from "../helpers/constants";

const contactsValueStyle = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "28px",
  color: "#4ba5dd",
  textDecoration: "none",
  padding: "0 5px",
};

const Callto = ({
  phone,
  children,
}: {
  phone: string;
  children: React.ReactNode;
}) => {
  return (
    <a style={contactsValueStyle} href={`tel:${phone}`}>
      {children}
    </a>
  );
};

export const useContactPopover = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "contact-popover" : undefined;

  // Close popover when clicking outside (anchor or popover content)
  React.useEffect(() => {
    if (!open || !anchorEl) return;
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as Node;
      if (anchorEl.contains(target)) return;
      const popoverPaper = document.querySelector("#contact-popover .MuiPopover-paper");
      if (popoverPaper?.contains(target)) return;
      handleClose();
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, anchorEl]);

  const ContactPopover = ({
    hideEmail = false,
    anchorOrigin = {
      vertical: "bottom",
      horizontal: "left",
    },
    transformOrigin = {
      vertical: "top",
      horizontal: "left",
    },
  }: {
    hideEmail?: boolean;
    anchorOrigin?: {
      vertical: "bottom" | "top" | "center";
      horizontal: "left" | "right" | "center";
    };
    transformOrigin?: {
      vertical: "bottom" | "top" | "center";
      horizontal: "left" | "right" | "center";
    };
  }) => (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      sx={{ zIndex: 111111111 }}
    >
      {!hideEmail && (
        <Typography sx={{ minHeight: "20px", minWidth: "35px" }} px={1} my={1}>
          Email :
          <SupportEmailLink
            email={SUPPORT_EMAIL}
            text={SUPPORT_EMAIL}
            sx={contactsValueStyle}
          />
        </Typography>
      )}
      <Typography sx={{ minHeight: "20px", minWidth: "35px" }} px={1} my={1}>
        Phone :{" "}
        <Callto phone={`${SUPPORT_PHONE}`}>{SUPPORT_PHONE_FORMAT}</Callto>
      </Typography>
    </Popover>
  );

  return {
    handleClick,
    handleClose,
    open,
    ContactPopover,
  };
};
